import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const ACTIVITY_REQUEST = "ACTIVITY_REQUEST";
export const ACTIVITY_SUCCESS = "ACTIVITY_SUCCESS";
export const ACTIVITY_ERROR = "ACTIVITY_ERROR";
const message = (error) => error?.response?.data?.message || error?.userMessage || "Riwayat aktivitas belum dapat dimuat.";

export const fetchActivityLogs = (params, signal) => async (dispatch) => {
  const requestId = `${Date.now()}-${Math.random()}`;
  dispatch({ type: ACTIVITY_REQUEST, requestId });
  try {
    const response = await authorizedAxios.get("/activity-logs", { params, signal });
    dispatch({ type: ACTIVITY_SUCCESS, requestId, data: response?.data?.data });
  } catch (error) {
    if (!signal?.aborted) dispatch({ type: ACTIVITY_ERROR, requestId, error: message(error) });
  }
};

export const fetchActivityDetail = async (id, signal, allOutlets = 0) => {
  const response = await authorizedAxios.get(`/activity-logs/${id}`, { signal, params: { all_outlets: allOutlets } });
  return response?.data?.data;
};

export const exportActivityLogs = async (params) => {
  const response = await showToast(authorizedAxios.get("/activity-logs/export", { params, responseType: "blob" }), {
    loading: "Menyiapkan riwayat aktivitas…", success: "Ekspor siap diunduh.", error: "Ekspor gagal. Maksimal 10.000 aktivitas; coba persempit filter.",
  });
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "riwayat-aktivitas.csv";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
